module.exports = require("clone");


//////////////////
// WEBPACK FOOTER
// external "clone"
// module id = 56
// module chunks = 0